import AbsoluteTimeLabel from './AbsoluteTimeLabel';
export default AbsoluteTimeLabel;